import React, { useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import "./ContactUs.css";
import { apiHandler } from "../../api";
import { API_BASE_URL, endpoint } from "../../api/endpoint";
import { useToasts } from "react-toast-notifications";
import { useSelector } from "react-redux";

export const ContactUs = () => {
  const { addToast } = useToasts();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    query: "",
  });
  const { authData, storeId } = useSelector((state) => state.loginSlice);

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim())
      newErrors.firstName = "First name is required.";
    if (!formData.lastName.trim())
      newErrors.lastName = "Last name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email address.";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required.";
    else if (!/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Phone must be 10 digits.";
    if (!formData.query.trim()) newErrors.query = "Query is required.";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) return;

    setIsSubmitting(true);
    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phone: formData.phone,
        query: formData.query,
      };

      const response = await apiHandler({
        url: endpoint.CONTACT_US,
        method: "POST",
        data: JSON.stringify(payload),
        authToken: authData,
        storeId,
        headers: { "Content-Type": "application/json" },
      });

      const status = response?.data?.status || response?.status;
      if (status === 201 || status === "success") {
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          query: "",
        });
        addToast(response?.data?.message, {
          appearance: "success",
          autoDismiss: true,
        });
      } else {
        alert("Failed to send message.");
      }
    } catch (err) {
      //console.error("API Error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-container">
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="card contact-card">
            <div className="row g-0">
              <div className="col-lg-8">
                <div className="form-section">
                  <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.firstName ? "is-invalid" : ""
                          }`}
                          name="firstName"
                          placeholder="First Name"
                          value={formData.firstName}
                          onChange={handleChange}
                        />
                        {errors.firstName && (
                          <div className="invalid-feedback">
                            {errors.firstName}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className={`form-control ${
                            errors.lastName ? "is-invalid" : ""
                          }`}
                          name="lastName"
                          placeholder="Last Name"
                          value={formData.lastName}
                          onChange={handleChange}
                        />
                        {errors.lastName && (
                          <div className="invalid-feedback">
                            {errors.lastName}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6 mb-3">
                        <input
                          type="email"
                          className={`form-control ${
                            errors.email ? "is-invalid" : ""
                          }`}
                          name="email"
                          placeholder="Email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                        {errors.email && (
                          <div className="invalid-feedback">{errors.email}</div>
                        )}
                      </div>
                      <div className="col-md-6">
                        <input
                          type="tel"
                          className={`form-control ${
                            errors.phone ? "is-invalid" : ""
                          }`}
                          name="phone"
                          placeholder="Phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                        {errors.phone && (
                          <div className="invalid-feedback">{errors.phone}</div>
                        )}
                      </div>
                    </div>

                    <div className="mb-3">
                      <textarea
                        className={`form-control ${
                          errors.query ? "is-invalid" : ""
                        }`}
                        name="query"
                        rows="4"
                        placeholder="Your message or query"
                        value={formData.query}
                        onChange={handleChange}
                      ></textarea>
                      {errors.query && (
                        <div className="invalid-feedback">{errors.query}</div>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          Submitting...
                          <span
                            className="spinner-border spinner-border-sm ms-2"
                            role="status"
                          />
                        </>
                      ) : (
                        <>
                          Submit <i className="bi bi-arrow-right ms-2"></i>
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </div>

              {/* RIGHT SIDE: CONTACT INFO */}
              <div className="col-lg-4">
                <div className="contact-info-section">
                  <div className="contact-info-item">
                    <div className="d-flex align-items-start">
                      <div className="contact-icon me-3">
                        <FaMapMarkerAlt size={24} />
                      </div>
                      <div>
                        <h3 className="contact-title">Address</h3>
                        <p className="fw-semibold mb-1">
                          Open Network For Digital Commerce (ONDC)
                        </p>
                        <p className="mb-1">
                          B 131, near Metro Station Noida Sector 15
                        </p>
                        <p className="mb-1">
                          B Block, Sector 2, Noida, Uttar Pradesh
                        </p>
                        <p className="mb-0">201301</p>
                      </div>
                    </div>
                  </div>

                  <div className="contact-info-item">
                    <div className="d-flex align-items-start">
                      <div className="contact-icon me-3">
                        <MdEmail size={24} />
                      </div>
                      <div>
                        <h3 className="contact-title">Connect with Us</h3>
                        <p className="mb-0">
                          <a
                            href="mailto:ondchelpdesk@futuresoftindia.com"
                            className="text-decoration-none"
                          >
                            ondchelpdesk@futuresoftindia.com
                          </a>
                          <br />
                          <a
                            href="tel:01204959000"
                            className="text-decoration-none"
                          >
                            Phone: 0120 495 9000
                          </a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END RIGHT SIDE */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
